import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowlessFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.21 7.03a1.25 1.25 0 0 1 1.674.086l7 7a1.25 1.25 0 0 1-1.768 1.768L12 9.768l-6.116 6.116a1.25 1.25 0 1 1-1.768-1.768l7-7z"
  }));
}
var IcArrowlessFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowlessFill));

export { IcArrowlessFill as I };
